import angular from "angular"
import angularBootstrap from "angular-ui-bootstrap";
import angularUiMask from "angular-ui-mask";
import angularMoment from "angular-moment";
import cgNotify from "@cgross/angular-notify";
import core from "../../core/core.module";
import capitalizeFirst from "../../capitalize-first/capitalize-first.module";

let mod = angular
    .module('passengerForm', [
        angularBootstrap,
        angularUiMask,
        angularMoment,
        cgNotify,
        core,
        capitalizeFirst
    ])
    .component('passengerForm', {
        template: require('./passengerForm.html'),
        controller: ['moment', 'notify', 'Data', '$scope', '$http', controller],
        bindings: {
            enableClientsModule: '<',
            client: '<',
            passenger: '<',
            ind: '<',
            citizenshipList: '<',
            docTypes: '<',
            depDate: '<',
            hasFemaleCars: '<',
            routesCount: '<',
        }
    });

function controller(moment, notify, Data, $scope, $http) {

    let $ctrl = this;

    // passenger data
    $ctrl.citizenship = null;
    $ctrl.docType = null;
    $ctrl.docNumber = null;
    $ctrl.iin = null;
    $ctrl.lastName = null;
    $ctrl.firstName = null;
    $ctrl.patronymic = null;
    $ctrl.birthDate = null;
    $ctrl.gender = null;
    $ctrl.tariff = null;
    $ctrl.phone = null;
    $ctrl.email = null;
    $ctrl.routesIssueFee = null;

    // additional data
    $ctrl.docNumberMask = null;
    $ctrl.iinRequired = false;
    $ctrl.showSearchField = false;
    $ctrl.errors = [];
    $ctrl.fields = {};
    $ctrl.save = false;

    $ctrl.fieldValues = {};

    $ctrl.$onInit = async function () {
        $ctrl.searchType = $ctrl.enableClientsModule
            ? ($ctrl.client.enable_employees_module ? 'by-employees' : 'by-passengers-log')
            : 'by-passengers-log';

        if ($ctrl.searchType === 'by-employees') {
            $ctrl.save = true;
        }

        $ctrl.searchPassenger = null;

        $ctrl.searchEmployee = null;

        $ctrl.showSearchField = true;

        $ctrl.citizenship = $ctrl.citizenshipList.find(v => {
            return $ctrl.passenger.citizenshipCode
                ? v.code === $ctrl.passenger.citizenshipCode
                : v.code === 'KAZ';
        });

        $ctrl.docType = $ctrl.docTypes.find(v => {
            return $ctrl.passenger.docTypeCode
                ? v.code === $ctrl.passenger.docTypeCode
                : v.code === 4;
        });

        $ctrl.docNumber = $ctrl.passenger.docNumber;
        $ctrl.iin = $ctrl.passenger.iin;
        $ctrl.lastName = $ctrl.passenger.lastName;
        $ctrl.firstName = $ctrl.passenger.firstName;
        $ctrl.patronymic = $ctrl.passenger.patronymic;
        $ctrl.birthDate = $ctrl.passenger.birthDate;
        $ctrl.gender = $ctrl.passenger.gender;
        $ctrl.tariff = $ctrl.passenger.tariff;
        $ctrl.phone = $ctrl.passenger.phone;
        $ctrl.email = $ctrl.passenger.email;

        if ($ctrl.passenger.employeeId) {
            try {
                const res = await $http.get('/data/get-employee', {
                    params: {
                        client_id: $ctrl.client.id,
                        employee_id: $ctrl.passenger.employeeId
                    }
                });

                $ctrl.searchEmployee = res.data.employee;

                $ctrl.searchEmployee.str = $ctrl.searchEmployee.last_name + ' ' +
                    $ctrl.searchEmployee.first_name + ' / ' +
                    $ctrl.searchEmployee.iin;

            } catch (e) {
                console.log(e);
            }
        }

        if ($ctrl.passenger.fieldValues) {
            $ctrl.fieldValues = {};

            $ctrl.passenger.fieldValues.forEach(v => {
                $ctrl.fieldValues[v.field_id] = v.value;
            })
        }

        $ctrl.routesIssueFee = [];

        for (let i = 0; i < $ctrl.routesCount; i++) {
            $ctrl.routesIssueFee[i] = $ctrl.client ? $ctrl.client.issue_fee : null;
        }

        $ctrl.setIinRequired();

        $ctrl.setDocNumberMask();

        $ctrl.validate();
    };

    $ctrl.setDocNumberMask = function () {
        let docTypeCode = $ctrl.docType ? $ctrl.docType.code : null;

        switch (docTypeCode) {
            case 0:
                $ctrl.docNumberMask = '99999999';
                break;

            case 1:
                $ctrl.docNumberMask = '9999999999';
                break;

            case 2:
                $ctrl.docNumberMask = '999999999';
                break;

            case 4:
                $ctrl.docNumberMask = '999999999';
                break;

            default:
                $ctrl.docNumberMask = '';
        }
    };

    $ctrl.setIinRequired = () => {
        $ctrl.iinRequired =
            $ctrl.citizenship &&
            $ctrl.citizenship.code === 'KAZ' &&
            $ctrl.docType &&
            ($ctrl.docType.code === 0 || $ctrl.docType.code === 4);
    };

    $ctrl.filterCitizenshipList = (fragment) => {
        return $ctrl.citizenshipList.filter(v => {
            return fragment ? v.title.toLowerCase().indexOf(fragment.toLowerCase()) === 0 : true
        });
    };

    $ctrl.filterDocTypes = () => {
        return $ctrl.docTypes.filter(v => {
            if ($ctrl.citizenship) {
                switch ($ctrl.citizenship.code) {
                    case 'KAZ':
                        return [0, 4, 5, 6, 9, 10].indexOf(v.code) !== -1;

                    case 'RUS':
                        return [1, 2, 5, 7, 8, 11].indexOf(v.code) !== -1;

                    case 'UZB':
                        return [3, 5, 8, 11].indexOf(v.code) !== -1;

                    default:
                        return [7, 8, 11].indexOf(v.code) !== -1;
                }
            }

            return false;
        });
    };

    $ctrl.citizenshipSelected = () => {
        $ctrl.docType = null;
        $ctrl.docNumber = null;
        $ctrl.setIinRequired();
        $ctrl.validate();
    };

    $ctrl.docTypeSelected = () => {
        $ctrl.docNumber = null;
        $ctrl.setDocNumberMask();
        $ctrl.setIinRequired();
        $ctrl.validate();
    };

    $ctrl.iinChanged = function () {
        if ($ctrl.iin && $ctrl.citizenship && $ctrl.citizenship.code === 'KAZ') {
            let birthDateStr = $ctrl.iin.slice(0, 6);

            let genderStr = +$ctrl.iin.slice(6, 7);

            let year = birthDateStr.slice(0, 2);

            if (+year > +moment().format('YY')) {
                birthDateStr = '19' + birthDateStr;
            } else {
                birthDateStr = '20' + birthDateStr;
            }

            let birthDate = moment(birthDateStr, 'YYYYMMDD');

            if (birthDate.isValid()) {

                if (!$ctrl.gender && genderStr >= 1 && genderStr <= 6) {
                    $ctrl.gender = genderStr % 2 ? 'male' : 'female';
                }

                if (!$ctrl.birthDate) {
                    $ctrl.birthDate = birthDate.format('DD.MM.YYYY');
                    $ctrl.birthDateChanged();
                }
            }
        }

        $ctrl.validate();
    };

    $ctrl.birthDateChanged = function () {
        if ($ctrl.birthDate) {
            let d = moment($ctrl.birthDate, 'DD.MM.YYYY');

            if (d.isValid()) {
                const passengerYearsOnTrainDep = moment($ctrl.depDate).diff(d, 'years');

                $ctrl.tariff = passengerYearsOnTrainDep > 14 ? 'full' : 'kid';
            }
        }

        $ctrl.validate();
    }

    $ctrl.validate = function () {

        $ctrl.errors = [];

        $ctrl.fields = {};

        if ($ctrl.citizenship) {
            $ctrl.fields['citizenship'] = 'success';
        }

        if ($ctrl.docType && $ctrl.docNumber) {
            $ctrl.fields['doc'] = 'success';
        }

        if ($ctrl.iin) {
            if ($ctrl.citizenship && $ctrl.citizenship.code === 'KAZ') {
                let birthDateStr = $ctrl.iin.slice(0, 6);

                let year = birthDateStr.slice(0, 2);

                if (+year > +moment().format('YY')) {
                    birthDateStr = '19' + birthDateStr;
                } else {
                    birthDateStr = '20' + birthDateStr;
                }

                let birthDate = moment(birthDateStr, 'YYYYMMDD');

                if (birthDate.isValid()) {
                    $ctrl.fields['iin'] = 'success';
                } else {
                    $ctrl.fields['iin'] = 'error';

                    $ctrl.errors.push('Неверный ИИН');
                }
            } else {
                $ctrl.fields['iin'] = 'success';
            }
        }

        if ($ctrl.lastName) {
            $ctrl.fields['lastName'] = 'success';
        }

        if ($ctrl.firstName) {
            $ctrl.fields['firstName'] = 'success';
        }

        if ($ctrl.patronymic) {
            $ctrl.fields['patronymic'] = 'success';
        }

        if ($ctrl.birthDate) {
            let d = moment($ctrl.birthDate, 'DD.MM.YYYY');

            if (d.isValid()) {
                $ctrl.fields['birthDate'] = 'success';
            } else {
                $ctrl.fields['birthDate'] = 'error';
                $ctrl.errors.push('Неверная дата рождения')
            }
        }

        if ($ctrl.gender) {
            $ctrl.fields['gender'] = 'success';
        }

        if ($ctrl.tariff === 'discount') {
            $ctrl.fields['tariff'] = 'error';

            $ctrl.errors.push('Применение дисконтной карты возможно только на кассе железнодорожного вокзала');

        } else if (!$ctrl.ind && $ctrl.tariff !== 'full') {
            $ctrl.fields['tariff'] = 'error';

            $ctrl.errors.push('Первый пассажир всегда должен оформляется по полному тарифу');

        } else if ($ctrl.birthDate && $ctrl.fields['birthDate'] === 'success') {
            const passengerYearsOnTrainDep = moment($ctrl.depDate).diff(moment($ctrl.birthDate, 'DD.MM.YYYY'), 'years');

            if ($ctrl.tariff === 'full') {
                $ctrl.fields['tariff'] = passengerYearsOnTrainDep > 14 ? 'success' : 'error';
            }

            if ($ctrl.tariff === 'kid') {
                $ctrl.fields['tariff'] = passengerYearsOnTrainDep < 15 ? 'success' : 'error';
            }

            if ($ctrl.fields['tariff'] === 'error') {
                $ctrl.errors.push('Возврат пассажира не соответствует выбранному тарифу');
            }

        } else if ($ctrl.tariff) {
            $ctrl.fields['tariff'] = 'success';
        }

        if ($ctrl.phone) {
            $ctrl.fields['phone'] = 'success';
        }

        if ($ctrl.email) {
            $ctrl.fields['email'] = 'success';
        }

        if ($ctrl.hasFemaleCars && $ctrl.birthDate && $ctrl.fields['birthDate'] === 'success' && $ctrl.gender) {
            if ($ctrl.gender !== 'female') {
                let d = moment($ctrl.birthDate, 'DD.MM.YYYY');

                const passengerYearsOnTrainDep = moment($ctrl.depDate).diff(d, 'years');

                if (passengerYearsOnTrainDep >= 7) {
                    $ctrl.errors.push('Поездка в женском вагоне разрешена для лиц мужского пола только до 7 лет');
                }
            }
        }

        fillPassenger();
    }

    function fillPassenger() {
        $ctrl.passenger.employeeId = $ctrl.searchEmployee ? $ctrl.searchEmployee.id : null;
        $ctrl.passenger.citizenshipCode = $ctrl.citizenship ? $ctrl.citizenship.code : null;
        $ctrl.passenger.docTypeCode = $ctrl.docType ? $ctrl.docType.code : null;
        $ctrl.passenger.docNumber = $ctrl.docNumber;
        $ctrl.passenger.iin = $ctrl.iin;
        $ctrl.passenger.lastName = $ctrl.lastName;
        $ctrl.passenger.firstName = $ctrl.firstName;
        $ctrl.passenger.patronymic = $ctrl.patronymic;
        $ctrl.passenger.birthDate = $ctrl.birthDate;
        $ctrl.passenger.gender = $ctrl.gender;
        $ctrl.passenger.tariff = $ctrl.tariff;
        $ctrl.passenger.phone = $ctrl.phone;
        $ctrl.passenger.email = $ctrl.email;
        $ctrl.passenger.routesIssueFee = $ctrl.routesIssueFee;
        $ctrl.passenger.fieldValues = $ctrl.client
            ? $ctrl.client.fields.map(field => { return {field_id: field.id, value: $ctrl.fieldValues[field.id] || null} })
            : null;
        $ctrl.passenger.hasErrors = !!$ctrl.errors.length;
        $ctrl.passenger.save = $ctrl.save;
    }

    $ctrl.searchPassengers = function (fragment) {
        return Data.getPassengers(fragment);
    };

    $ctrl.passengerSelected = function () {
        $ctrl.citizenship = $ctrl.citizenshipList.find(v => v.code === $ctrl.searchPassenger.citizenship);
        $ctrl.docType = $ctrl.docTypes.find(v => v.code === $ctrl.searchPassenger.doc_type);
        $ctrl.docNumber = $ctrl.searchPassenger.doc_number;
        $ctrl.iin = $ctrl.searchPassenger.iin;
        $ctrl.lastName = $ctrl.searchPassenger.last_name;
        $ctrl.firstName = $ctrl.searchPassenger.first_name;
        $ctrl.patronymic = $ctrl.searchPassenger.patronymic;
        $ctrl.birthDate = $ctrl.searchPassenger.birth_date
            ? moment($ctrl.searchPassenger.birth_date).format('DD.MM.YYYY')
            : null;
        $ctrl.gender = $ctrl.searchPassenger.gender;
        $ctrl.phone = $ctrl.searchPassenger.phone_number
            ? $ctrl.searchPassenger.phone_number.match(/\d/g).join('').substr(1)
            : null;
        $ctrl.email = $ctrl.searchPassenger.email;
        $ctrl.validate();
    };

    $ctrl.searchEmployees = function (fragment) {
        return Data.getEmployees($ctrl.client.id, fragment);
    };

    $ctrl.searchFields = function (fragment, field) {
        if (!fragment) return field.options_array;
        return field.options_array.filter(x => x.toLowerCase().includes(fragment.toLowerCase()));
    };

    $ctrl.employeeSelected = function () {
        $ctrl.citizenship = $ctrl.citizenshipList.find(v => v.code === $ctrl.searchEmployee.citizenship_code);
        $ctrl.iin = $ctrl.searchEmployee.iin;
        $ctrl.lastName = $ctrl.searchEmployee.last_name;
        $ctrl.firstName = $ctrl.searchEmployee.first_name;
        $ctrl.patronymic = $ctrl.searchEmployee.patronymic;
        $ctrl.birthDate = $ctrl.searchEmployee.birth_date
            ? moment($ctrl.searchEmployee.birth_date).format('DD.MM.YYYY')
            : null;
        $ctrl.gender = $ctrl.searchEmployee.gender;
        $ctrl.phone = $ctrl.searchEmployee.phone_number
            ? $ctrl.searchEmployee.phone_number.match(/\d/g).join('').substr(1)
            : null;
        $ctrl.email = $ctrl.searchEmployee.email;

        const doc = $ctrl.searchEmployee.docs[0];

        if (doc) {
            let x = -1;

            if ($ctrl.citizenship.code === 'KAZ') {
                if (doc.type === 'identity-card') {
                    x = 4;
                } else if (doc.type === 'passport') {
                    x = 0;
                }
            } else {
                if ($ctrl.citizenship.code === 'RUS' && doc.type === 'passport') {
                    x = 1;
                } else if ($ctrl.citizenship.code === 'UZB' && doc.type === 'passport') {
                    x = 3;
                } else if (doc.type === 'residence') {
                    x = 11;
                } else {
                    x = 7;
                }
            }

            if (x !== -1) {
                $ctrl.docType = $ctrl.docTypes.find(v => v.code === x);
                $ctrl.docNumber = doc.number;
            }
        }

        $ctrl.fieldValues = {};

        $ctrl.client.fields.forEach(field => {
            const fieldValue = $ctrl.searchEmployee.field_values.find(v => v.field_id === field.id);

            if (fieldValue && fieldValue.value) {
                if (field.type === 'numeric') {
                    $ctrl.fieldValues[field.id] = !isNaN(fieldValue.value) ? +fieldValue.value : null;
                } else {
                    $ctrl.fieldValues[field.id] = fieldValue.value;
                }
            } else if (field.pivot.default_value) {
                if (field.type === 'numeric') {
                    $ctrl.fieldValues[field.id] = !isNaN(field.pivot.default_value) ? +field.pivot.default_value : null;
                } else {
                    $ctrl.fieldValues[field.id] = field.pivot.default_value;
                }
                $ctrl.fieldValues[field.id] = fieldValue ? fieldValue.value : '';
            }
        });

        $ctrl.validate();
    };

    $ctrl.empFieldChanged = function () {
        fillPassenger();
    };
}

export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/passengerForm/passengerForm.js